<template>
    <el-drawer
        title="发货"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                v-if="itemData"
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                <el-form-item prop="orderDetailIds">
                    <el-table
                        :data="deliverGoodsList"
                        style="width: 100%"
                        v-loading="listLoading"
                        size="small"
                        border
                        @selection-change="handleSelectionChange"
                        ref="listTable"
                    >
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column prop="goodsName" label="商品" min-width="200"></el-table-column>
                        <el-table-column prop="skuName" label="SKU" min-width="200"></el-table-column>
                        <el-table-column prop="noDeliverNum" label="待发货数量" min-width="90"></el-table-column>
                        <el-table-column prop="deliverNum" label="已发货数量" min-width="90"></el-table-column>
                        <el-table-column prop="expressId" label="快递公司" min-width="80"></el-table-column>
                        <el-table-column prop="expressNo" label="运单号" min-width="120"></el-table-column>
                        <el-table-column prop="expressTime" label="发货时间" min-width="150"></el-table-column>
                    </el-table>
                </el-form-item>
                <el-row :gutter="30">
                    <el-col :xs="24" :md="12">
                        <el-form-item prop="expressName">
                            <span slot="label">
                                快递公司:    
                                <small>如果没有所需的快递公司，请联系研发进行添加</small>
                            </span>
                            <el-select v-model="formDatas.expressName" size="medium" placeholder="请选择快递公司">
                                <el-option v-for="(item,index) in expressList" :key="index" :value="item.expressName" :label="item.expressName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12">
                        <el-form-item prop="expressNo" label="运单号:" >
                            <el-input v-model="formDatas.expressNo" placeholder="请输入运单号" size="medium" maxlength="40"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-alert type="warning" show-icon :closable="false" title="先勾选需要发货的商品，然后提交发货信息。对于已发货的商品，可以提交修改发货信息。"></el-alert>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchExpress} from '@/assets/js/commonApi';
const defaultFormData = {
    expressName:'',
    expressNo:'',
    orderDetailIds: ''
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultFormData,
            },
            rules:{
                orderDetailIds: [{required: true, message: '请勾选需要发货的商品',  trigger: 'change'}],
                expressName:[{required: true, message: '请选择快递公司'}],
                expressNo:[{required: true, message: '请输入运单号'}]
            },
            itemData:null,
            expressList:[],
            listLoading: false,
            deliverGoodsList: [],
            goodsArry: []
        }
    },
    created(){
        this.getExpressList();
    },
    methods:{
        close(){
            this.formDatas = { ...defaultFormData };
            this.$refs.formDatas.resetFields();
            this.goodsArry = [];
            this.drawerShow = false;
        },
        show(data){
            this.itemData = data;
            this.formDatas = {
                ...defaultFormData,
                // orderId:data.id,
                orderSn: data.sn
            }
            this.getDeliverGoodsList();
            this.drawerShow = true;
        },
        getExpressList(){
            fetchExpress().then((res) => {
                const {state,result} = res.data;
                if(state == 1){
                    this.expressList = result;
                }
            }).catch(() => {})
        },
        getDeliverGoodsList(){
            this.listLoading = true;
            this.$request({
                url: '/goodOrder/deliverGoodsList',
                params:{
                    id: this.itemData.id
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.deliverGoodsList = result || [];
                        this.$nextTick(() => {
                            this.deliverGoodsList.forEach(row => {
                                this.$refs.listTable.toggleRowSelection(row);
                            });
                        })
                    } else {
                        this.$message.error(msg || "获取订单发货列表失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取订单发货列表失败,请重试");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //全选、反选
        handleSelectionChange(val) {
            this.goodsArry = val;
            this.formDatas.orderDetailIds = (this.goodsArry.map( v => v.orderDetailId)).toString()
        },
        submitForm(){
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/goodOrder/singleDeliverGoods',
                        data:{
                            ...this.formDatas,
                            // orderDetailIds: (this.goodsArry.map( v => v.orderDetailId)).toString()
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>